type LocationLike = {
  hostname?: string;
};

const LOCAL_FLOW_MAP_ORIGIN = "http://localhost:3102";
const DEFAULT_FLOW_MAP_ORIGIN = "https://platform.blings.io";

function isLocalHost(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".localhost")
  );
}

export function getFlowMapOrigin(locationLike?: LocationLike): string {
  const hostname = locationLike?.hostname;

  if (!hostname || isLocalHost(hostname)) {
    return LOCAL_FLOW_MAP_ORIGIN;
  }

  const labels = hostname.split(".");
  const studioIndex = labels.indexOf("studio");

  if (studioIndex >= 0) {
    const subdomainLabels = labels.slice(0, studioIndex);
    return `https://${[...subdomainLabels, "platform", "blings", "io"].join(
      "."
    )}`;
  }

  if (
    hostname === "platform.blings.io" ||
    hostname.endsWith(".platform.blings.io")
  ) {
    return `https://${hostname}`;
  }

  return DEFAULT_FLOW_MAP_ORIGIN;
}

export function getFlowMapEmbedUrl(
  projectId: string,
  locationLike: LocationLike = window.location
): string {
  return `${getFlowMapOrigin(locationLike)}/embed/project/${encodeURIComponent(
    projectId
  )}/flow-map`;
}
